import React, { useState, forwardRef, useEffect } from 'react';
import { styled } from '@mui/material/styles';
import Radio from '@mui/material/Radio';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormGroup from '@mui/material/FormGroup';
// import { Switch } from 'antd';
import Switch from '@mui/material/Switch';
import Checkbox from '@mui/material/Checkbox';
import { Button, TextField, Box, Typography, IconButton, InputAdornment } from '@mui/material';
import { ReactComponent as Upload } from '../../../assets/images/ChatImages/upload.svg';
import { ReactComponent as Dot } from '../../../assets/images/list-dot.svg';
import CheckedIcon from '../../../assets/images/checkedIcon.png';
import UncheckedIcon from '../../../assets/images/uncheckedIcon.png';
import Input from '../../common/InputField';
import Autocomplete from '@mui/material/Autocomplete';
import IOSSwitch from '../../common/IOSswitch';
import './style.css';

const AdvanceSettings = ({ preChat, guestMode, welcomeMessage, placeholderText, offlineInfo, offlineTitle, onPreChatChange, onGuestModeChange, onWelcomeMessageChange, onPlaceholderTextChange, onOfflineInfoChange, onOfflineTitleChange, showLogo, showAgentPhoto, sound, label, onAgentPhotoChange, onShowLogoChange, onSoundChange, onLabelChange, onLogoChange, nameRequired, onNameCheckboxChange, emailRequired, onEmailCheckboxChange, showWelcomeScreen, onShowWelcomeScreenChange, startChatAlways, onStartChatAlwaysChange }) => {

  const [roleAgent, setRoleAgent] = useState(0)
  const [preChatIn, setPreChatIn] = useState(preChat);
  const [guestModeIn, setGuestModeIn] = useState(guestMode);

  const handleLogoUpload = (event) => {
    const file = event.target.files[0];
    if (file) {
      const previewUrl = URL.createObjectURL(file);
      onLogoChange(previewUrl, file);
    }
  };

  const handlePreChatChange = (event) => {
    setPreChatIn(event.target.checked);
    onPreChatChange(event.target.checked);
  };

  const handleGuestModeChange = (event) => {
    setGuestModeIn(event.target.checked);
    onGuestModeChange(event.target.checked);
  };

  const handleAlways = () => {
    onStartChatAlwaysChange(true);
  };

  const handleOnly = () => {
    onStartChatAlwaysChange(false);
  };

  return (
    <div>

      <p className="parInfoStart">Customers can start a chat</p>
      <div className='startChat'>
        <div className='WidgetRoleAgentStatus'>
          <FormControlLabel
            value={'Always'}
            control={<Radio />}
            onClick={handleAlways}
            checked={startChatAlways === true}
            sx={{ margin: '0' }}
          />
          <span style={{ fontWeight: '500', fontSize: '14px', lineHeight: '20px' }}>Always</span>
          <div style={{ marginLeft: '20px', color: '#556575', fontSize: '14px' }}>
            <ul style={{ listStyle: 'none', lineHeight: '28px', paddingLeft: '22px' }}>
              <li className='status-list'><Dot className="list-icon" />Customers can send messages even if you're away.</li>
              <li className='status-list'><Dot className="list-icon" />You'll see their messages as unassigned chats.</li>
              <li className='status-list'><Dot className="list-icon" />Customers will get an email with your reply.</li>
              <li className='status-list'><Dot className="list-icon" />Chat history is available for both agents and customers.</li>
            </ul>
          </div>
        </div>

        <div className='WidgetRoleAgentStatus' style={{ marginTop: '8px' }}>
          <FormControlLabel
            value={'Only'}
            control={<Radio />}
            onClick={handleOnly}
            checked={startChatAlways === false}
            sx={{ margin: '0' }}
          />
          <span style={{ fontWeight: '500', fontSize: '14px', lineHeight: '20px' }}>Only when agents are accepting chats</span>
          <div style={{ marginLeft: '20px', color: '#556575', fontSize: '14px' }}>
            <ul style={{ listStyle: 'none', lineHeight: '28px', paddingLeft: '25px' }}>
              <li className='status-list'><Dot className="list-icon" />Customers can't start a chat when you're away.</li>
              <li className='status-list'><Dot className="list-icon" />With HelpDesk, customers will be able to leave tickets that you can</li>
              <li className='status-list'><Dot className="list-icon-hid" />handle once you're available Available with.</li>
            </ul>
          </div>
        </div>

        <p className="Settings-Line-Bottom" />

      </div>

      <div className='preChatContainer'>
        <FormControlLabel
          control={<IOSSwitch checked={preChat} sx={{ m: 1 }} onChange={handlePreChatChange} />}
          label="Pre-Chat Form"
          componentsProps={{
            typography: {
              style: { fontSize: '14px', fontWeight: 'bold' },
            },
          }}
        />
        <p style={{ marginLeft: '3rem', marginTop: '-4px', marginBottom: '20px', color: '#556575', fontSize: '14px', lineHeight: '20px' }}>Pre-Chat Form allowed you to gather visitor information before chat</p>

        {preChat && (
          <>
            <div style={{ marginLeft: '3rem' }}>
              {/* <label >
            Setup for:
          </label>
          <Autocomplete
            disableClearable
            options={['Agents']}
            sx={{ margin: '10px 0', fontSize: '14px'}}
            size="small"
            renderInput={(params) => <TextField {...params} label="All" />}
          /> */}
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '6px' }}>

                <span className='cs-text'>Name</span>
                <div>
                  <span className='cs-text' style={{ paddingRight: '8px' }}>Required</span>
                  <input
                    type="checkbox"
                    className="custom-checkbox"
                    id="nameCheckbox"
                    name="nameCheckbox"
                    checked={nameRequired}
                    onChange={onNameCheckboxChange}
                  />
                  <label htmlFor="nameCheckbox">
                    <span className="Remember__01"></span>
                  </label>
                </div>

              </div>
              <input
                title="Name"
                className="cs-input"
                placeholder=""
              />

              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: '15px', marginBottom: '6px' }}>

                <span className='cs-text'>Email</span>
                <div>
                  <span className='cs-text' style={{ paddingRight: '8px' }}>Required</span>
                  <input
                    type="checkbox"
                    className="custom-checkbox"
                    id="emailCheckbox"
                    name="emailCheckbox"
                    checked={emailRequired}
                    onChange={onEmailCheckboxChange}
                  />
                  <label htmlFor="emailCheckbox">
                    <span className="Remember__01"></span>
                  </label>
                </div>

              </div>
              <input
                title="Email"
                className="cs-input"
                placeholder=""
              />
            </div>

            <FormControlLabel
              control={<IOSSwitch checked={guestMode} sx={{ m: 1 }} onChange={handleGuestModeChange} />}
              label="Allow Guests"
              componentsProps={{
                typography: {
                  style: { fontSize: '14px', fontWeight: 'bold' },
                },
              }}
            />
            <p style={{ marginLeft: '3rem', marginTop: '-4px', marginBottom: '20px', color: '#556575', fontSize: '14px', lineHeight: '20px' }}>Show start chat as a guest button </p>
          </>
        )}
      </div>

      <p className="Settings-Line-Bottom-Welcome" />
      <p className="parInfo">Welcome your customers</p>

      <div className="welcomeContainer">
        <div className="welcomeMsg">
          <Input
            title="Welcome message"
            placeholder=""
            value={welcomeMessage}
            onChange={(e) => onWelcomeMessageChange(e.target.value)}
          />
          <Input
            title="Message placeholder"
            placeholder=""
            value={placeholderText}
            onChange={(e) => onPlaceholderTextChange(e.target.value)}
          />
        </div>

        <div style={{ display: 'flex', flexDirection: 'column' }}>
          <p className="settingsInfoText">Customers can still start a chat. They’ll see offline info and <span style={{ color: '#148DFD', textDecoration: 'underline', textUnderlineOffset: "2px" }}>ask for email</span> form.</p>
          <Input
            title="Offline title"
            placeholder="Create a ticket"
            value={offlineTitle}
            maxLength={24}
            error={offlineTitle.length >= 24 ? "Max length is 24 characters" : null}
            onChange={(e) => onOfflineTitleChange(e.target.value)}
          />
          <label style={{ marginTop: '16px' }}>
            Offline info
          </label>
          <textarea
            className="offline-info-textarea"
            style={{ marginTop: '8px', height: '80px', borderRadius: '8px', border: '1px solid #C5CED6', resize: 'none', padding: '13px 16px', fontFamily: 'Aerial, sans-serif', lineHeight: '18px' }}
            placeholder={`Our team is currently offline. Please create a ticket.`}
            value={offlineInfo}
            maxLength={120}
            onChange={(e) => onOfflineInfoChange(e.target.value)}
          />
          {offlineInfo.length >= 120 && <p className="InputErrorMsg">Max length is 120 characters</p>}
        </div>
      </div>

      {/* <p className="Settings-Line-Bottom" />
      <p className="parInfo">Visibility</p>

      <div className="visibilityContainer">
        <p className="settingsInfoText">Control when to display the chat widget icon on your website.</p>

        <div>
          <FormControlLabel
            value={'Always'}
            style={{ marginRight: '0px' }}
            control={<Radio />}
          />
          <span style={{fontWeight: 'bold', fontSize: '14px'}}>The chat widget is always visible</span>
          <div style={{ marginLeft: '2rem', color: '#556575', fontSize: '14px'}}>
            <p style={{ marginTop: '-2px' }}>Display the widget icon on your site to let customers start a chat.</p>
          </div>
        </div>

        <div style={{ marginTop: '18px' }}>
          <FormControlLabel
            value={'Always'}
            style={{ marginRight: '0px' }}
            control={<Radio />}
          />
          <span style={{fontWeight: 'bold', fontSize: '14px'}}>Hide widget until it gets activated</span>
          <div style={{ marginLeft: '2rem', color: '#556575', fontSize: '14px' }}>
            <p style={{ marginTop: '-2px' }}>Once a chat is started, the widget will appear and will remain visible.</p>
          </div>
        </div>

        <div style={{ marginTop: '18px' }}>
          <FormControlLabel
            value={'Always'}
            style={{ marginRight: '0px' }}
            control={<Radio />}
          />
          <span style={{fontWeight: 'bold', fontSize: '14px'}}>Always hide minimized widget icon</span>
          <div style={{ marginLeft: '2rem', color: '#556575', fontSize: '14px' }}>
            <p style={{ marginTop: '-2px' }}>Customers won’t be able to start chats unless you <span style={{color: '#148DFD', textDecoration: 'underline'}}>add a clickable chat button</span> to your website.</p>
          </div>
        </div>
      </div> */}

      <p className="Settings-Line-Bottom" />

      <p className="parInfo">Settings</p>
      <div className="showSettingsContainer">
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <div>
            <FormControlLabel
              control={<IOSSwitch checked={showLogo} onChange={onShowLogoChange} sx={{ m: 1, mr: 0 }} />}
              componentsProps={{
                typography: {
                  style: { fontSize: '14px' },
                },
              }}
            />
            <span style={{ marginLeft: '-8px', fontSize: '14px', color: '#556575' }}>
              Show logo
            </span>
          </div>
          <Button
            style={{ background: 'transparent', boxShadow: 'none', padding: '0' }}
            variant="contained"
            component="label"
          >
            <span style={{ color: "#148DFD", fontSize: "14px", textDecoration: "underline", textTransform: "none", textUnderlineOffset: "3px" }}>Upload your logo</span>
            <input type="file" hidden onChange={handleLogoUpload} />
          </Button>
        </div>
        <div sx={{ width: '100%' }}>
          <FormControlLabel
            control={<IOSSwitch checked={showAgentPhoto} onChange={onAgentPhotoChange} sx={{ m: 1, mr: 0 }} />}
            componentsProps={{
              typography: {
                style: { fontSize: '14px' },
              },
            }}
          />
          <span style={{ marginLeft: '-8px', fontSize: '14px', color: '#556575' }}>
            Show agent’s photo
          </span>
        </div>
        <div sx={{ width: '100%' }}>
          <FormControlLabel
            control={<IOSSwitch checked={sound} onChange={onSoundChange} sx={{ m: 1, mr: 0 }} />}
            componentsProps={{
              typography: {
                style: { fontSize: '14px' },
              },
            }}
          />
          <span style={{ marginLeft: '-8px', fontSize: '14px', color: '#556575' }}>
            Enable sound notifications for customers
          </span>
        </div>
        <div sx={{ width: '100%' }}>
          <FormControlLabel
            control={<IOSSwitch checked={label} onChange={onLabelChange} sx={{ m: 1, mr: 0 }} />}
            componentsProps={{
              typography: {
                style: { fontSize: '14px' },
              },
            }}
          />
          <span style={{ marginLeft: '-8px', fontSize: '14px', color: '#556575' }}>
            White label widget
          </span>
        </div>
        {/* <FormControlLabel
          control={<IOSSwitch sx={{ m: 1 }} defaultChecked />}
          label="Let customers rate agents"
          componentsProps={{
            typography: {
              style: { fontSize: '14px' },
            },
          }}
          sx={{ width: '100%' }}
        />
        <FormControlLabel
          control={<IOSSwitch sx={{ m: 1 }} defaultChecked />}
          label="Let customers get chat transcripts"
          componentsProps={{
            typography: {
              style: { fontSize: '14px' },
            },
          }}
          sx={{ width: '100%' }}
        />
        */}


        <p className="Settings-Line-Bottom" />

        <FormControlLabel
          control={<IOSSwitch checked={showWelcomeScreen} onChange={onShowWelcomeScreenChange} sx={{ m: 1 }} />}
          label="Show welcome screen"
          componentsProps={{
            typography: {
              style: { fontSize: '14px', fontWeight: 'bold' },
            },
          }}
          sx={{ width: '100%' }}
        />
        <p style={{ marginLeft: '3rem', marginTop: '-4px', color: '#556575', fontSize: '14px' }}>Decide whether customers should see a welcome screen in your chat widget.</p>

      </div>

    </div>
  )
};
export default AdvanceSettings;